/* ASKROA Variant Description Switcher - All Rings v3 */
(function(){
  var proIds = [
    55055337128227,55055337160995,55055337193763,55055337226531,55055337259299,55272086143267,
    55272631042339,55272631075107,55272631107875,55272631140643,55272631173411,55272631206179,
    55272088699171,55272088731939,55272088764707,55272088797475,55272088830243,55272088863011
  ];
  var liteEl = null, proEl = null;

  function switchTo(isPro) {
    if (!liteEl) liteEl = document.querySelector('[data-lite]');
    if (!proEl) proEl = document.querySelector('[data-pro]');
    if (!liteEl || !proEl) return;
    liteEl.style.display = isPro ? 'none' : 'block';
    proEl.style.display = isPro ? 'block' : 'none';
  }

  function isProId(id) {
    return proIds.indexOf(Number(id)) !== -1;
  }

  function init() {
    /* 1. 初始狀態：從 URL 讀取 */
    var vid = new URL(window.location.href).searchParams.get('variant');
    switchTo(isProId(vid));

    /* 2. Dawn variant:change 事件 */
    document.addEventListener('variant:change', function(e) {
      if (e.detail && e.detail.variant) {
        switchTo(isProId(e.detail.variant.id));
      }
    });

    /* 3. 點擊事件：直接檢查 data-value 文字 */
    document.addEventListener('click', function(e) {
      var val = e.target.getAttribute('data-value') || e.target.value || '';
      if (val === 'PRO') { switchTo(true); return; }
      if (val === 'LITE') { switchTo(false); return; }
      var parent = e.target.closest('[data-value]');
      if (parent) {
        val = parent.getAttribute('data-value');
        if (val === 'PRO') { switchTo(true); return; }
        if (val === 'LITE') { switchTo(false); return; }
      }
    });

    /* 4. 後備：攔截 URL 變化 */
    var origPush = history.pushState;
    history.pushState = function() {
      origPush.apply(this, arguments);
      setTimeout(function() {
        var v = new URL(window.location.href).searchParams.get('variant');
        switchTo(isProId(v));
      }, 50);
    };
    var origReplace = history.replaceState;
    history.replaceState = function() {
      origReplace.apply(this, arguments);
      setTimeout(function() {
        var v = new URL(window.location.href).searchParams.get('variant');
        switchTo(isProId(v));
      }, 50);
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
